import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_BIZ_PATH = process.env.VUE_APP_BIZ_PATH

const VUE_APP_LOCALSTORAGE_TENANTID = process.env.VUE_APP_LOCALSTORAGE_TENANTID
const localStorageTenantId = localStorage.getItem(VUE_APP_LOCALSTORAGE_TENANTID)

//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 查询车间列表
     * @return {Promise}
     */
    // eslint-disable-next-line no-unused-vars
    async getWorkshopList({ commit }, query) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/workshop/list`;
        const result = await request.get(url, {params:query});
        //获取服务返回数据
        return result;
    },

    // 查询车间详细
    async getWorkshop({ commit }, { id }) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/enterprise/workshop/${id}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result;
    },

    // 添加车间
    async addWorkshop(state, params) {
        let url = `${VUE_APP_BIZ_PATH}/enterprise/workshop`;
        const result = await request.post(url, params);
        return result;
    },
    // 修改车间
    async editWorkshop(state, params) {
        let url = `${VUE_APP_BIZ_PATH}/enterprise/workshop`;
        const result = await request.put(url, params);
        return result;
    },
    // 删除车间
    async deleteWorkshop({ commit }, { ids }){
        let url = `${VUE_APP_BIZ_PATH}/enterprise/workshop/${encodeURIComponent(ids)}`;
        const result = await request.delete(url);
        return result;
    },
    // 根据客户查询工厂
    async getFactoryByCustomer({ commit }) {
        //发起request
        const url = `${VUE_APP_BIZ_PATH}/downList/factory`;
        const VUE_APP_LOCALSTORAGE_TENANTID = process.env.VUE_APP_LOCALSTORAGE_TENANTID
        const localStorageTenantId = localStorage.getItem(VUE_APP_LOCALSTORAGE_TENANTID)
        const result = await request.get(url,{params:{tenantId:localStorageTenantId}});
        //获取服务返回数据
        return result;
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }